module.exports = {
  "props": [
    {
      "name": "alt-labels",
      "type": "boolean",
      "default": "false",
      "source": "v-stepper",
      "description": {
        "en": "Places the labels beneath the step",
        "eo-UY": ""
      }
    },
    {
      "name": "dark",
      "type": "boolean",
      "default": "false",
      "source": "themeable",
      "description": {
        "en": "Applies the dark theme variant to the component. You can find more information on the Material Design documentation for [dark themes](https://material.io/design/color/dark-theme.html).",
        "eo-UY": ""
      }
    },
    {
      "name": "light",
      "type": "boolean",
      "default": "false",
      "source": "themeable",
      "description": {
        "en": "Applies the light theme variant to the component.",
        "eo-UY": ""
      }
    },
    {
      "name": "non-linear",
      "type": "boolean",
      "default": "false",
      "source": "v-stepper",
      "description": {
        "en": "Allow user to jump to any step",
        "eo-UY": ""
      }
    },
    {
      "name": "value",
      "type": "any",
      "default": "undefined",
      "source": "proxyable",
      "description": {
        "en": "The designated model value for the component.",
        "eo-UY": ""
      }
    },
    {
      "name": "vertical",
      "type": "boolean",
      "default": "false",
      "source": "v-stepper",
      "description": {
        "en": "Display steps vertically",
        "eo-UY": ""
      }
    }
  ],
  "mixins": [
    "proxyable",
    "registrable-provide",
    "themeable"
  ],
  "slots": [
    {
      "name": "default",
      "description": {
        "en": "The default Vue slot.",
        "eo-UY": ""
      }
    }
  ],
  "events": [
    {
      "name": "change",
      "value": "number",
      "description": {
        "en": "Emitted when step is changed by user interaction",
        "eo-UY": ""
      }
    }
  ],
  "functions": [],
  "name": "v-stepper",
  "sass": [
    {
      "name": "$stepper-alt-labels-flex-basis",
      "default": "175px !default;",
      "description": {
        "en": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$stepper-alt-labels-header-divider",
      "default": "35px -67px 0 !default;",
      "description": {
        "en": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$stepper-alt-labels-step-step-margin-bottom",
      "default": "11px !default;",
      "description": {
        "en": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$stepper-border-radius",
      "default": "$border-radius-root !default;",
      "description": {
        "en": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$stepper-content-btn-margin",
      "default": "24px 8px 8px 0 !default;",
      "description": {
        "en": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$stepper-content-padding",
      "default": "24px 24px 16px 24px !default;",
      "description": {
        "en": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$stepper-elevation",
      "default": "2 !default;",
      "description": {
        "en": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$stepper-header-divider-margin",
      "default": "0 -16px !default;",
      "description": {
        "en": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$stepper-header-elevation",
      "default": "2 !default;",
      "description": {
        "en": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$stepper-header-height",
      "default": "72px !default;",
      "description": {
        "en": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$stepper-label-line-height",
      "default": "1 !default;",
      "description": {
        "en": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$stepper-label-small-font-size",
      "default": "map-deep-get($headings, 'caption', 'size') !default;",
      "description": {
        "en": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$stepper-label-small-font-weight",
      "default": "300 !default;",
      "description": {
        "en": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$stepper-step-error-icon-font-size",
      "default": "map-deep-get($headings, 'h5', 'size')  !default;",
      "description": {
        "en": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$stepper-step-padding",
      "default": "24px !default;",
      "description": {
        "en": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$stepper-step-step-font-size",
      "default": "map-deep-get($headings, 'caption', 'size') !default;",
      "description": {
        "en": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$stepper-step-step-height",
      "default": "24px !default;",
      "description": {
        "en": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$stepper-step-step-icon-font-size",
      "default": "map-deep-get($headings, 'h6', 'size') !default;",
      "description": {
        "en": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$stepper-step-step-margin",
      "default": "8px !default;",
      "description": {
        "en": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$stepper-step-step-min-width",
      "default": "24px !default;",
      "description": {
        "en": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$stepper-step-step-width",
      "default": "24px !default;",
      "description": {
        "en": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$stepper-vertical-content-ltr-margin",
      "default": "-8px -36px -16px 36px !default;",
      "description": {
        "en": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$stepper-vertical-content-rtl-margin",
      "default": "-8px 36px -16px -36px !default;",
      "description": {
        "en": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$stepper-vertical-content-padding",
      "default": "16px 60px 16px 23px !default;",
      "description": {
        "en": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$stepper-vertical-padding-bottom",
      "default": "36px !default;",
      "description": {
        "en": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$stepper-vertical-step-padding",
      "default": "24px 24px 16px !default;",
      "description": {
        "en": "",
        "eo-UY": ""
      }
    },
    {
      "name": "$stepper-vertical-step-step-margin",
      "default": "12px !default;",
      "description": {
        "en": "",
        "eo-UY": ""
      }
    }
  ],
  "component": true
}